import TermsStep from './TermsStep';

export default TermsStep;
